import React from 'react';

import AssemblyHandler from './handlers/assembly-handler';
import TemplateHandler from './handlers/template-handler';
import { useSentry } from '../sentry';
import { usePageMeta } from '../page';

const withErrorHandler = (UnsafeComponent, Handler) => (props) => {
  const Sentry = useSentry();
  const { contentfulId, path, type } = usePageMeta();

  try {
    return UnsafeComponent(props);
  } catch (error) {
    if (Sentry) {
      Sentry.withScope((scope) => {
        scope.setExtra('contentfulId', contentfulId);
        scope.setExtra('path', path);
        scope.setExtra('page-type', type);
        Sentry.captureException(error);
      });
    } else {
      console.error(error);
    }

    return <Handler error={error} name={UnsafeComponent.name} />;
  }
};

export const SafeAssembly = (Component) =>
  withErrorHandler(Component, AssemblyHandler);

export const SafeTemplate = (Template) =>
  withErrorHandler(Template, TemplateHandler);
